// ===================================================================
// Pendências de folhas escaneadas (objetiva ou redação) — admin
// ===================================================================

import React from 'react';
import { styles } from '../../styles/globalStyles';

export const ExamPendingScansPanel = React.memo(
  ({ pendingRows, pendingLinkDraft, setPendingLinkDraft, pendingBusy, onLink, onDiscard }) => {
    if (!pendingRows?.length) return null;

    return (
      <div style={{ ...styles.card, marginBottom: 16 }}>
        <h3 style={{ ...styles.cardTitle, fontSize: 16, marginBottom: 8 }}>Pendências ({pendingRows.length})</h3>
        <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>
          Não foi possível identificar a inscrição. Informe o número e vincule.
        </p>
        <table style={{ ...styles.table, marginTop: 12 }}>
          <thead style={styles.tableHeader}>
            <tr>
              <th style={styles.tableHeaderCell}>Arquivo</th>
              <th style={styles.tableHeaderCell}>Motivo</th>
              <th style={styles.tableHeaderCell}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {pendingRows.map((p) => (
              <tr key={p.id} style={styles.tableRow}>
                <td style={styles.tableCell}>
                  {p.preview_url ? (
                    <a href={p.preview_url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12 }}>
                      {p.original_filename}
                    </a>
                  ) : (
                    p.original_filename
                  )}
                </td>
                <td style={{ ...styles.tableCell, fontSize: 12 }}>{p.reject_reason || '—'}</td>
                <td style={styles.tableCell}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
                    <input
                      type="number"
                      placeholder="Nº inscrição"
                      value={pendingLinkDraft[p.id] ?? ''}
                      onChange={(e) => setPendingLinkDraft((d) => ({ ...d, [p.id]: e.target.value }))}
                      style={{ ...styles.input, width: 110, fontSize: 12 }}
                    />
                    <button
                      type="button"
                      disabled={pendingBusy === p.id}
                      onClick={() => onLink(p.id)}
                      style={{ ...styles.button, ...styles.buttonPrimary, fontSize: 10, padding: '4px 8px' }}
                    >
                      Vincular
                    </button>
                    <button
                      type="button"
                      disabled={pendingBusy === p.id}
                      onClick={() => onDiscard(p.id)}
                      style={{ ...styles.button, ...styles.buttonDanger, fontSize: 10, padding: '4px 8px' }}
                    >
                      Descartar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
);
